import { Controller } from 'stimulus';

const calculateCircleSize = (element, margin) => {
  const computedStyle = window.getComputedStyle(element);

  const paddingTop = parseFloat(computedStyle.paddingTop);
  const paddingBottom = parseFloat(computedStyle.paddingBottom);

  const width = parseFloat(computedStyle.width);
  const height = parseFloat(computedStyle.height) - paddingTop - paddingBottom;

  const widthWithMargin = width + margin;
  const heightWithMargin = height + margin;

  // √(width^2 + height^2) calculates the diameter of the text rectangle
  // https://math.stackexchange.com/questions/854535/how-can-i-find-the-smallest-enclosing-circle-for-a-rectangle
  const diameter = Math.sqrt((widthWithMargin ** 2) + (heightWithMargin ** 2));

  return {
    diameter,
    margin: (diameter - height) / 2,
  };
};

class CircleContent extends Controller {
  connect() {
    this.onResizeBound = this.onResize.bind(this);
    window.addEventListener('resize', this.onResizeBound);
    this.onResize();
  }

  disconnect() {
    window.removeEventListener('resize', this.onResizeBound);
  }

  onResize() {
    const extraMargin = window.innerWidth < 768 ? 45 : 120;
    const { diameter, margin } = calculateCircleSize(this.textTarget, extraMargin);

    this.setCircleWidth(diameter);
    this.setVerticalMargin(margin);
  }

  setCircleWidth(diameter) {
    this.circleTarget.style.width = `${diameter}px`;
    this.circleTarget.style.height = `${diameter}px`;
  }

  setVerticalMargin(margin) {
    this.textTarget.style.paddingTop = `${margin}px`;
    this.textTarget.style.paddingBottom = `${margin}px`;
  }
}

CircleContent.targets = [
  'circle',
  'text',
];

export default CircleContent;
